module.exports = __webpack_public_path__ + "img/review-1.7675b45b.png";